// App JS for frontend

console.log('Front app loaded');
